import script from "./dashboards.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboards.vue?vue&type=script&setup=true&lang=js"

import "./dashboards.vue?vue&type=style&index=0&id=031f76fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-031f76fe"]])

export default __exports__